import RemoteConfigService from './remote';

export {
    RemoteConfigService
};



// WEBPACK FOOTER //
// ./app/services/config/index.js